import { getClientEnv } from "./env";
import type { AuthMode } from "./session";

export type PlatformShellConfig = {
  auth_mode: AuthMode;
  platform_name: string;
  logo_url: string | null;
  favicon_url: string | null;
  maintenance_mode: boolean;
};

function parseBoolean(value: string | undefined, fallback = false) {
  if (!value) return fallback;
  const normalized = value.trim().toLowerCase();
  if (["1", "true", "yes", "on"].includes(normalized)) return true;
  if (["0", "false", "no", "off"].includes(normalized)) return false;
  return fallback;
}

function resolveAuthMode(): AuthMode {
  return "sso";
}

export function getPlatformShellConfig(): PlatformShellConfig {
  return {
    auth_mode: resolveAuthMode(),
    platform_name: getClientEnv("UMI_APP_PLATFORM_NAME", "VITE_PLATFORM_NAME") || "AIRange",
    logo_url: getClientEnv("UMI_APP_PLATFORM_LOGO_URL", "VITE_PLATFORM_LOGO_URL") || null,
    favicon_url: getClientEnv("UMI_APP_PLATFORM_FAVICON_URL", "VITE_PLATFORM_FAVICON_URL") || null,
    maintenance_mode: parseBoolean(getClientEnv("UMI_APP_PLATFORM_MAINTENANCE_MODE", "VITE_PLATFORM_MAINTENANCE_MODE"), false),
  };
}
